
 

 

 

    import UserCriteria01 from 'Modules/Core/Scripts/UserCriteria01';

    import PagingCriteria from 'Lib/Fs.Core.Data/PagingCriteria';

 
class ManageUserGroupMemberSearchParameter 
{
    
        Criteria: UserCriteria01;
    
        SortingCriteria: any;
    
        PagingCriteria: PagingCriteria;
    
}
 
export default ManageUserGroupMemberSearchParameter;
 




